import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Alte Blog-URLs der Vorgängerseite auf die heutigen Ratgeber-Seiten
 * weiterleiten, damit vorhandene Google-Rankings nicht ins Leere laufen.
 */
const MAP: Record<string, string> = {
  "shopify-seo": "/blog/shopify-seo-optimierung-guide",

  "shopify-conversion-optimierung": "/ratgeber/shopify-conversion-optimierung",
  "conversion-rate-optimierung": "/ratgeber/conversion-rate-optimierung",
  "shopify-produktseite-optimieren": "/ratgeber/shopify-produktseite-optimieren",
  "shopify-pagespeed-optimieren": "/ratgeber/shopify-pagespeed-optimieren",
  "shopify-mobile-optimierung": "/ratgeber/shopify-mobile-optimierung",
  "shopify-kosten": "/ratgeber/shopify-kosten",
  "shopify-agentur-kosten": "/ratgeber/shopify-agentur-kosten",
  "shopify-ab-testing": "/ratgeber/shopify-ab-testing",
  "shopify-migration": "/ratgeber/shopify-migration",
  "shopify-vs-woocommerce": "/ratgeber/shopify-vs-woocommerce",
  "shopify-entwickler": "/ratgeber/shopify-entwickler",
  "shopify-experte": "/ratgeber/shopify-experte",
  "shopify-conversion-rate-optimierung": "/ratgeber/conversion-rate-optimierung",
  "shopify-b2b-shop-einrichten": "/ratgeber/shopify-b2b-shop-einrichten",
  "was-kostet-shopify-conversion-optimierung": "/ratgeber/shopify-agentur-kosten",
  "shopify-warenkorbabbrueche-reduzieren": "/ratgeber/shopify-warenkorbabbrueche-reduzieren",
  "shopify-conversion-rate-benchmark": "/ratgeber/shopify-conversion-rate-benchmark",
};

export const Route = createFileRoute("/blog/$slug")({
  beforeLoad: ({ params }) => {
    const target = MAP[params.slug.replace(/\/$/, "")] ?? "/ratgeber";
    throw redirect({ href: target, statusCode: 301 });
  },
  component: () => null,
});
